import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import '../Styles/Content.css';
import Sidebar from './Sidebar';
import Buddhism from './Map/Buddhism';
import BuddhismPage from './Map/BuddhismPage';
import ChristianityPage from './Map/ChristianityPage';
import IslamPage from './Map/IslamPage'; 
import HinduismPage from './Map/HinduismPage';
import EastPage from './Map/EastPage';
import OtherPage from './Map/OtherPage';
import Christianity from './Map/Christianity';
import Islam from './Map/Islam';
import EastAsian from './Map/EastAsian';
import Hinduism from './Map/Hinduism';
import Other from './Map/Other';
import Map from './Map/Map';
import HomeMap from './Map/HomeMap';


export default class Content extends Component {
    render() {
        return (
            <div className="content">
                <Routes>
                    <Route path="/" element={<HomeMap />} />
                    <Route path="/Buddhism" element={<BuddhismPage />} />
                    {/* <Route path="/" element={<Buddhism />} /> */}
                    <Route path="/Christianity" element={<ChristianityPage />} />
                    <Route path="/East" element={<EastPage />} />
                    <Route path="/Islam" element={<IslamPage />} />
                    <Route path="/Hinduism" element={<HinduismPage />} />
                    <Route path="/Other" element={<OtherPage />} />
                </Routes>
            </div>
        )
    }
}
